module.exports = "<template> <div class=\"tyl-badge tyl-badge--open\" part=root> <slot></slot> </div> </template>";